import { render, staticRenderFns } from "./beer.vue?vue&type=template&id=f38b65aa"
import script from "./beer.vue?vue&type=script&lang=js"
export * from "./beer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports